import { atom } from 'recoil';
import { UserDetail } from '../connector/type';

export enum Pick {
  NONE = '',
  PLAYER = 'PLAYER',
  BANKER = 'BANKER',
  TIE = 'TIE'
}

export enum PickType {
  NONE = '',
  PAST = 'p',
}

export interface PickHistoryItem {
  timestamp: number;
  round: number;
  amount: number;
  pick: string;
  result: string;
}

const defaultUserDetail: UserDetail = {
  id: '',
  nickname: '',
  level: 0,
  hasThumbnail: false,
  todayComment: '',
  gasMask: false,
  familyNickname: '',
  decorationItem: false,
  maxStreak: 0,
  sniperItem: false,
};

export enum ProjectStatus {
  NONE_PROJECT = 0,
  WAIT = 1,
  READY = 2, // 프리미엄를 생성했지만, 시작하지 않은 상태
  PLAY = 3,
  ACHIEVE = 4, // ACHIEVE -> 새로운 프리미엄 생성 -> READY
  DEFEAT = 5 // ACHIEVE -> 새로운 프리미엄 생성 -> READY
}

type Project = {
  id: string;
  projectPrice: number;
  projectParticipants: string[];
  projectStartAmount: number;
  projectTargetAmount: number;
  projectAmount: number;
  projectType: string;
  projectHistory: PickHistoryItem[];
};

const roomDetailState = atom({
  key: 'roomDetail',
  default: {
    id: '',
    owner: '',
    participants: 0,
    uniqueParticipants: 0,
    name: '',
    description: '',
    maxParticipants: 0,
    isProject: false,
    isSecret: false,
    ownerDetail: defaultUserDetail,
    pick: Pick.NONE,
    pickAmount: 0,
    pickHistory: [{} as PickHistoryItem],
    projectStatus: ProjectStatus.NONE_PROJECT,
    projectType: '',
    projectStartAmount: 0,
    projectTargetAmount: 0,
    projectAmount: 0,
    projectParticipants: [''],
    project: {} as Project,
    record: {
      win: 0,
      defeat: 0,
    },
    recommenders: [''],
    giftedBullets: 0,
    managers: [''],
    isAllFreezing: false,
  }
});

export default roomDetailState;

export const kickState = atom({
  key: 'kick',
  default: '',
});
